import styled from 'styled-components';

interface BaseProps {
	isMobile: boolean;
	sidebarVisible: boolean;
	sidebarDocked: boolean;
	sidebarWidth: number;
}

export const Base = styled.div<BaseProps>`
	position: relative;
	height: 100vh;
	background-color: ${({ theme }) => theme.gray[0]};

	${({ isMobile, sidebarDocked, sidebarWidth }) =>
		isMobile
			? `
		display: block;
	`
			: `
		display: grid;
		grid-template-columns: ${sidebarDocked ? `${sidebarWidth}px 1fr` : '0 1fr'};
		transition: none;
	`}
`;

interface MainContentProps {
	isMobile: boolean;
	sidebarVisible: boolean;
	sidebarWidth: number;
}

export const MainContent = styled.div<MainContentProps>`
	height: 100vh;
	overflow: hidden;
	position: relative;

	${({ isMobile, sidebarVisible, sidebarWidth }) =>
		isMobile
			? `
		width: 100%;
		transform: ${sidebarVisible ? `translateX(${sidebarWidth}px)` : 'none'};
		transition: transform 0.3s ease;
		backdrop-filter: ${sidebarVisible ? 'blur(2px)' : 'none'};
	`
			: `
		grid-column: 2;
	`}
`;
